export const optionsType = [
    {id: 1, name: "Upper"},
    {id: 2, name: "Lower"},
    {id: 3, name: "SBR Element"},
    {id: 4, name: "Module"},
    {id: 5, name: "Module Compact"},
]
